import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/image/vipImg/icon_tab_vip@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-2edee671"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "openMemberModal_newMemberActivity_box" }
const _hoisted_2 = {
  key: 0,
  class: "newMember"
}
const _hoisted_3 = {
  class: "newMemberInfo abs flex-col-aisrt",
  style: {"top":"60px","left":"40px","text-align":"left"}
}
const _hoisted_4 = { class: "newMemberInfoSpan" }
const _hoisted_5 = {
  key: 0,
  class: "flex-cen-ter"
}
const _hoisted_6 = { class: "numBack flex-cen-ter" }
const _hoisted_7 = {
  key: 0,
  class: "symbol"
}
const _hoisted_8 = { class: "newMemberInfoSpan" }
const _hoisted_9 = {
  key: 1,
  class: "flex-cen-ter"
}
const _hoisted_10 = {
  key: 0,
  class: "newMemberInfoSpan"
}
const _hoisted_11 = { class: "numBack flex-cen-ter" }
const _hoisted_12 = {
  key: 0,
  class: "symbol"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "newMemberBtn abs cursor-pt" }, null, -1))
const _hoisted_15 = {
  key: 1,
  class: "wrap"
}
const _hoisted_16 = { class: "header" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "explain mt_30" }
const _hoisted_20 = { style: {"padding":"20px 30px"} }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_22 = { class: "ml_10 text" }

import { ref, computed } from 'vue'
import { useRtfix, isJA, useSite2Station, isKO, useSite } from '@/store'
import { useStore } from 'vuex'
import { t } from '@/plugins/i18n'
import { Site } from '@/common/const'
import { getCurrentMonetaryUnit, getActivePriceByStation } from '@/util/useYan'


export default /*#__PURE__*/_defineComponent({
  emits: ['closeMember'],
  setup(__props, { expose, emit: emits }) {

const store = useStore()
const isSub = store.getters.isSub

const memberVisible = ref(false)
const onlyOpenSpecail = computed(() => store.getters.onlyOpenSpecail)
const newMemberActivity = computed(() => store.state.status.newMemberActivity.id ? store.state.status.newMemberActivity : false)

const countryCurrency = getCurrentMonetaryUnit()
const getBackgroundImage = () => {
  if (isJA()) {
    return 'https://static-s.theckb.com/BusinessMarket/member/new_member_cart_pop_up_background_short@2x.png'
  } else if (isKO()) {
    return 'https://static-s.theckb.com/BusinessMarket/member/cart_vip_pop_background_short@2x.png'
  } else {
    return 'https://static-s.theckb.com/BusinessMarket/member/cart_vip_pop_background_short_en.png'
  }
}
const open = () => {
  memberVisible.value = true
}
const closeModal = () => {
  memberVisible.value = false
}
const explainList = ref([
  {
    id: 1,
    text: t('能够在中国找到丰富的供应商')
  },
  {
    id: 2,
    text: t('按照日本质量标准进行检验（隶属于日本公司）')
  },
  {
    id: 3,
    text: t('最低国际运费保证，可运往23个国家/地区')
  },
  {
    id: 4,
    text: t('可靠的支持和即时的客户服务')
  }
])
expose({
  open
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: memberVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((memberVisible).value = $event)),
      width: _unref(newMemberActivity)&&!_unref(onlyOpenSpecail)?'500px':'600px',
      "custom-class": `openMemberModal ${_unref(newMemberActivity)&&!_unref(onlyOpenSpecail)?'openMemberModal_newMemberActivity':''}`,
      onClose: closeModal
    }, {
      default: _withCtx(() => [
        (_unref(newMemberActivity)&&!_unref(onlyOpenSpecail))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)("首次入会")), 1),
                (_unref(isJA)())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createTextVNode(_toDisplayString(_unref(newMemberActivity).specialPrice), 1),
                        (!_unref(newMemberActivity).hasSpecialTrialDiscount)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, "％"))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(newMemberActivity).hasSpecialTrialDiscount?'円': 'OFF') + _toDisplayString(_unref(t)('で中国輸入代行サービス体験可能！')), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      (_unref(newMemberActivity).hasSpecialTrialDiscount)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(countryCurrency)), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_11, [
                        _createTextVNode(_toDisplayString(_unref(newMemberActivity).specialPrice), 1),
                        (!_unref(newMemberActivity).hasSpecialTrialDiscount)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, "％"))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("span", {
                        class: _normalizeClass(["newMemberInfoSpan", _unref(useSite)()])
                      }, _toDisplayString(_unref(newMemberActivity).hasSpecialTrialDiscount?'': 'OFF') + _toDisplayString(_unref(t)('で中国輸入代行サービス体験可能！')), 3)
                    ]))
              ]),
              _createElementVNode("img", {
                class: "abs",
                src: getBackgroundImage(),
                alt: ""
              }, null, 8, _hoisted_13),
              _createVNode(_component_router_link, {
                to: _unref(useRtfix)('VipLevel')
              }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              }, 8, ["to"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                (_unref(isSub))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("p", null, _toDisplayString(_unref(t)('开通会员，即可享受下单代买服务。')), 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(t)('请联系主账号开通。')), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("p", null, _toDisplayString(_unref(t)('开通会员，即可享受下单代买服务。')), 1)
                    ]))
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("ul", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(explainList.value, (item) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: item.id,
                      class: "list flex ter"
                    }, [
                      _hoisted_21,
                      _createElementVNode("p", _hoisted_22, _toDisplayString(item.text), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _createVNode(_component_router_link, {
                to: _unref(useRtfix)('VipLevel')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, { class: "btn mt_30" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(isSub)? _unref(t)('查看会员'):_unref(t)('开通会员')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["to"])
            ]))
      ]),
      _: 1
    }, 8, ["modelValue", "width", "custom-class"])
  ]))
}
}

})